/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/21/20
 * Time: 6:10 PM
 */
import React, {Component} from 'react';
import './HealthDeclaration.scss';
import {Button} from "semantic-ui-react";
import * as healthConstants from '../../../const/health/Health';
import * as routeConstants from "../../../const/route/Route";
import {withRouter} from "react-router-dom";

class App extends Component {

  onResultHander = (index, result) => {
    let i = index+1;
    let {health, active, max} = this.props.healthObj;
    health[i-1].result = result;

    let success_  = i === max ? i : (i+1);
    let active_   = active === max ? max : i + 1;

    this.props.covidDetails({...this.props.healthObj,health, active: active_, success: success_ , curIndex: i});
    if(i === 7 && result === healthConstants.NO_RESULT && max > i){
      health[i].result = result;
      this.props.changeLocation(3);
      this.props.covidDetails({...this.props.healthObj,health, active: active_, success: success_ , curIndex: i});
      return;
    }
    if(i === max){
      this.props.changeLocation(3)
    }
  };

  countHandler = (status) => {
    let {active, success} = this.props.healthObj;
    let count = status === "BACK" ? active > 1 ? active - 1 : active : success > active ? active + 1 : active;
    this.props.changeState("active",count)
  };

  render() {
    let {health, active, max, success, curIndex} = this.props.healthObj;
    let obj = health[active - 1];

    return (
      <div className={"health-tile"}>

        {obj && <div className={"tile"}>
          <div className={"p-head"}>
            <Button icon='left arrow' className={`left-button ${active > 1 ? `act-btn` : `disbl-btn`}`}
                    onClick={() => this.countHandler("BACK")}/>
            {`${active}/${max}`}
            <Button icon='right arrow' className={`right-button ${success > active || success > max ? `act-btn`: `disbl-btn`}`} onClick={() => this.countHandler("NEXT")}/>
          </div>
          <p className={"p-tile"}>{obj.english}</p>
          <p className={"p-tile sinhala-font"}>{obj.sinhala}</p>
          <p className={"p-tile tamil-font"}>{obj.tamil}</p>
          {/*<p className={"p-tile"}>{obj.chinese}</p>*/}

          <div className={"btn-wrapper"}>
            <Button content='Yes' icon='check' labelPosition='left' className={`yes-btn ${obj.result === healthConstants.YES_RESULT ? `yes-success`:``}`}
                    onClick={() => this.onResultHander(obj.index, healthConstants.YES_RESULT)}/>
            <Button content='No' icon='close' labelPosition='right' className={`no-btn ${obj.result === healthConstants.NO_RESULT ? `no-success`:``}`}
                    onClick={() => this.onResultHander(obj.index, healthConstants.NO_RESULT)}/>

          </div>
        </div>}
            <div className={"back-btn-wrapper align-center"}>
              <Button className="back-btn ui button"
                      onClick={()=>this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/profile`)}>Back</Button>
              {
                curIndex === max ?
                  <Button className="submit-btn ui button"
                          onClick={()=>this.props.changeLocation(3)}>Next</Button>:null
              }
            </div>

      </div>
    );
  }
}

export default withRouter(App);
